
import { Vue, Component } from 'vue-property-decorator';
import DeviceLayout from '@/ui/components/devices/components/DeviceLayout.vue';
import InputFieldMock from '@/ui/components/devices/previews/components/InputFieldMock.vue';

@Component({
  components: {
    DeviceLayout,
    InputFieldMock,
  },
})
export default class VariableTextInputFieldPreview extends Vue {
  get previewNameLang() {
    return this.$t('devices.VariableTextInputField.previewName');
  }
}
